exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footerlist__title[data-v-88008256]{margin-bottom:9px;font-family:inherit;text-transform:uppercase;font-size:15px;line-height:1.25;color:#292929}.footerlist__list[data-v-88008256]{list-style:none}.footerlist__item[data-v-88008256]{margin-bottom:12px}.footerlist__item[data-v-88008256]:last-child{margin-bottom:0}.footerlist__text[data-v-88008256]{color:#666;line-height:1.25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88008256","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/modulefooter/components/modulefooterlist/ModuleFooterList.vue
// module id = 725a74ab6ec7f0f4a7cd
// module chunks = 0